import React from 'react';

import { colors } from 'common/styles/style-constants';
import { CloseOutlined } from 'opencare-crown';
import { PartnerLogoInner } from 'pages/common/components/PartnerLogo/styled-components';
import { Img } from 'pages/profile/components/ProfileOfficePhotos/styled-components';

interface PartnerLogoProps {
  partner: any;
  height?: number;
  isCollaborationIconVisible?: boolean;
}

/**
 * Renders the logo image of a partner with optional features.
 */
export const PartnerLogo = ({
  partner,
  height,
  isCollaborationIconVisible,
}: PartnerLogoProps) => {
  if (!partner?.logoURL) {
    return null;
  }

  return (
    <PartnerLogoInner>
      {isCollaborationIconVisible && <CloseOutlined style={{ color: colors.ash }} />}
      <Img alt={partner.name} src={partner.logoURL} style={{ width: 'auto', height: height ?? 30 }} />
    </PartnerLogoInner>
  );
};

